<template>
  <div class="grid-view">
    <div class="main-content">
      <search-bar config-module="3300003" :filter="searchConditions" :ocr-tab="OCR_TAB_TRASH.code" @toQuery="toQuery" @change="searchChange" />
      <div class="section grid-wrapper">
        <intelligent-booking-table :row-data="rowData" config-module="3300023" tab-type="tabTrash" />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="intelligent-tab-trash"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="queryPageHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IntelligentBookingTable from '@/views/cargo/v0/ToolAssistant/ocr/components/IntelligentBookingTable'
import { getLoading } from '@/utils/utilBaseElement'
import { advancedQueryIntelligentDocument, queryIntelligentBookingList } from '@/api/seaExport/intelligentBooking'
import SearchBar from '@/views/cargo/v0/ToolAssistant/ocr/components/SearchBar'
import { OCR_TAB_TRASH } from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'TabTrash',
  components: { SearchBar, IntelligentBookingTable },
  data() {
    return {
      rowData: [],
      searchConditions: {
        total: 0,
        iType: -1,
        pageNum: 1,
        pageSize: 50,
        status: [4]
      },
      OCR_TAB_TRASH
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchData()
    },
    fetchData(params = this.searchConditions) {
      console.log('fetchFinished')
      this.loading = getLoading()
      advancedQueryIntelligentDocument(params).then(res => {
        const { data } = res
        this.rowData = data.list
        this.searchConditions.total = Number(data.total)
        this.searchConditions.pageNum = data.pageNum
        this.searchConditions.pageSize = data.pageSize
      }).finally(() => {
        this.loading.close()
      })
    },
    queryPageHandler() {
      this.fetchData(this.searchConditions)
    },
    searchChange(e) {
      console.log(e)
      const params = this.searchConditions
      params.pageNum = 1
      switch (e.type) {
        case 'input':
          params.fileName = e.value
          break
        case 'select':
          params.iType = e.value
          break
        default:
          if (e.value) {
            params.days = e.value
          }
          params.fileName = ''
          break
      }
      this.fetchData(params)
    },
    toQuery() {
      this.fetchData()
    }
  }
}
</script>

<style scoped>

</style>
